import { IonIcon, useIonToast } from '@ionic/react';
import { checkmarkOutline, closeOutline } from 'ionicons/icons';
import React from 'react';
import { UpdateUserNetworkFunc, useUser } from '../../hooks/WPHooks';
import { useIntl } from 'react-intl';
import { ModelsService } from '../../services/ModelsService';

export interface FriendRequestItemProps {
  idUser: number;
  idNetwork: number;
  update: UpdateUserNetworkFunc;
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export const FriendRequestItem: React.FC<FriendRequestItemProps> = ({
  idUser,
  idNetwork,
  update,
}) => {
  const { user } = useUser(idUser, true);

  const intl = useIntl();
  const [present] = useIonToast();

  const success = (msgId: string) => {
    present({
      color: 'primary',
      position: 'top',
      message: intl.formatMessage({ id: msgId }),
      duration: 3000,
    });
  };

  const acceptFriendRequest = () => {
    update(idNetwork, {
      acf: {
        relation_status: 'accepted',
      },
    }).then(() => success('Friend Request Action Success #accept'));
  };

  const refusedFriendRequest = () => {
    update(idNetwork, {
      acf: {
        relation_status: 'refused',
      },
    }).then(() => success('Friend Request Action Success #refuse'));
  };

  // relative border-b border-gray-200 py-5 flex items-center space-x-3 focus:bg-primary

  return (
    <>
      {user && (
        <li className="cursor-default py-4 px-6 flex items-center gap-x-4 md:rounded-2xl bg-white">
          <div className="flex-shrink-0">
            <img
              className="h-12 w-12 rounded-full object-cover"
              src={ModelsService.getUserAvatar(user)}
              alt=""
            />
          </div>
          <div className="flex-1 min-w-0 text-left pl-2">
            <p className="text-sm font-medium text-gray-900">{user.name}</p>
            <p className="text-xs text-gray-500 truncate">
              {ModelsService.getUserHouseName(user)}
            </p>
          </div>
          <div className="flex mt-0.5 mr-4">
            <div className="rounded-full h-6 w-6 cursor-pointer border flex items-center justify-center border-redNotif mr-6">
              <button
                className="flex justify-center items-center rounded-full h-6 w-6 hover:bg-redNotif"
                onClick={refusedFriendRequest}
              >
                <IonIcon
                  size="large"
                  icon={closeOutline}
                  className="text-redNotif hover:text-white"
                />
              </button>
            </div>
            <div className="rounded-full h-6 w-6 cursor-pointer border flex items-center justify-center border-primary mr-4">
              <button
                className="flex justify-center items-center rounded-full h-6 w-6 hover:bg-primary"
                onClick={acceptFriendRequest}
              >
                <IonIcon
                  size="large"
                  icon={checkmarkOutline}
                  className={classNames(
                    'text-primary hover:text-white stroke-2'
                  )}
                />
              </button>
            </div>
          </div>
        </li>
      )}
    </>
  );
};
